import ToolsService from "@/services/ToolsService";
import { useContributionStore } from "@/store/contribution.store";
import { computed } from "vue";

export default class ContributionViewModel {
  public breadcrumbs = [
    {
      title: "Dashboard",
      disabled: false,
      href: "/app/home",
    },
    {
      title: "Detalle de Aportes",
      disabled: true,
      href: "",
    },
  ];
  public contributionStore = useContributionStore();
  public toolsService = new ToolsService();
  public contribution = computed(
    () => this.contributionStore.getSelectedContribution
  );
  public formattedTotal = computed(() => {
    const moneda = this.contribution.value?.moneda || "";
    const saldoAporte = this.contribution.value?.saldoaporte || 0;
    return `${this.formatCoin(moneda)} ${this.formatFloat(saldoAporte)}`;
  });
  constructor() {
    console.log("contrution view");
  }
  formatDateISO(date: string) {
    return this.toolsService.formatDateISO(date);
  }
  formatHour(hour: string) {
    return this.toolsService.formatHour(hour);
  }
  formatCoin(coin: number) {
    return this.toolsService.getCoin(coin);
  }
  formatFloat(decimal: number) {
    return this.toolsService.getFloat(decimal);
  }
  getColor(tipoMov: string): string {
    switch (tipoMov) {
      case "1": // Movimiento de ingreso
        return "success"; // Verde
      case "2": // Movimiento de retiro
        return "error"; // Rojo
      default: // Otro tipo de movimiento
        return "primary"; // Color predeterminado
    }
  }

  getIconName(tipoMov: string): string {
    switch (tipoMov) {
      case "1": // Movimiento de ingreso
        return "mdi-arrow-top-right"; // Flecha hacia arriba
      case "2": // Movimiento de retiro
        return "mdi-arrow-bottom-left"; // Flecha hacia abajo
      default: // Otro tipo de movimiento
        return "mdi-wallet"; // Ícono genérico
    }
  }
}
